import {
  localizationEnUsMarketplace,
  routerPageMarketplace,
} from "./marketplace";
import { localizationEnUsProduct, routerPageProduct } from "./product";
import { localizationEnUsCart, routerPageCart } from "./cart";
import {
  localizationEnUsStoreCheckout,
  routerPageStoreCheckout,
} from "./checkout";
import {
  localizationEnUsStoreCheckoutComplete,
  routerPageStoreCheckoutComplete,
} from "./checkout-complete";

export const localizationEnUsStore = {
  ...localizationEnUsMarketplace,
  ...localizationEnUsProduct,
  ...localizationEnUsCart,
  ...localizationEnUsStoreCheckout,
  ...localizationEnUsStoreCheckoutComplete,
};

export const routersPageStore = [
  routerPageMarketplace,
  routerPageProduct,
  routerPageCart,
  routerPageStoreCheckout,
  routerPageStoreCheckoutComplete,
];
